/**
 * messageReadStore
 * Persists message read-state to localStorage so it survives
 * component unmounts, page refreshes, and navigation away/back.
 *
 * Shared by MessagesPlaceholderView (marks messages read) and
 * UsefulInfoSidebar (reads unread count).
 */

const LS_KEY = 'zaxia_read_msg_ids';

/** Return the full set of IDs the guest has already opened. */
export function getReadIds(): Set<string> {
  try {
    const raw = localStorage.getItem(LS_KEY);
    return raw ? new Set(JSON.parse(raw) as string[]) : new Set();
  } catch {
    return new Set();
  }
}

/** Mark one or more message IDs as read and persist to localStorage. */
export function markRead(...ids: string[]): void {
  const current = getReadIds();
  ids.forEach(id => current.add(id));
  try {
    localStorage.setItem(LS_KEY, JSON.stringify([...current]));
  } catch {
    // quota exceeded or private browsing — silently ignore
  }
  // Dispatch a custom event so any listening component can update its counter.
  window.dispatchEvent(new CustomEvent('zaxia:messages-read'));
}

/** Return true if this message has been opened. */
export function isRead(id: string): boolean {
  return getReadIds().has(id);
}
